export const ATTENDANCE_STATUS_OPTIONS = [
  { label: 'Todos', value: '' },
  { label: 'Ativo', value: 'ACTIVE' },
  { label: 'Pendente', value: 'WAITING' },
  { label: 'Em atendimento', value: 'ATTENDING' },
  { label: 'Concluido', value: 'CONCLUDED' },
  { label: 'Cancelado', value: 'CANCELLED' },
  { label: 'Inativo', value: 'INACTIVE' },
]
